import { PUBLIC_ENVIRONMENT_STAGE } from '$env/static/public';
import { IEnvironment } from '../types';

type INavigation = {
  label: string;
  url: string;
  disabled: boolean;
};

export enum NavigationUrl {
  ROOT = '/',
  MARKETS = '/markets',
  DASHBOARD = '/dashboard',
  POINTS = '/points',
  FAUCET = '/faucet',
  RESERVE_OVERVIEW = '/reserve-overview',
  STAKING = '/staking',
}

export const NavigationData: INavigation[] = [
  {
    label: 'Markets',
    url: NavigationUrl.MARKETS,
    disabled: false,
  },
  {
    label: 'Dashboard',
    url: NavigationUrl.DASHBOARD,
    disabled: false,
  },
  ...(PUBLIC_ENVIRONMENT_STAGE !== IEnvironment.PRODUCTION
    ? [
        {
          label: 'Faucet',
          url: NavigationUrl.FAUCET,
          disabled: false,
        },
      ]
    : []),
  // {
  //   label: 'Points',
  //   url: NavigationUrl.POINTS,
  //   disabled: true,
  // },
  // {
  //   label: 'Staking',
  //   url: NavigationUrl.STAKING,
  //   disabled: false,
  // },
];
